export const Status = Object.freeze({
  LOADING: 'loading'
})
